// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2wUua","productName":"Table_productName__1m8-F"};